"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
var React = require("react");
var ReactDOM = require("react-dom");
var common_1 = require("./common");
var utility_1 = require("../../commoncomponents/src/utility");
var ImageItem_1 = require("../../commoncomponents/src/carousel/ImageItem");
var utility_2 = require("../utility");
var CheckOutLoading = /** @class */ (function (_super) {
    __extends(CheckOutLoading, _super);
    function CheckOutLoading(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShowLoading: false
        };
        return _this;
    }
    CheckOutLoading.prototype.componentDidMount = function () {
        var _this = this;
        window["onHandleShowCheckOutLoading"] = function (isShowLoading) {
            if (isShowLoading === void 0) { isShowLoading = null; }
            if (isShowLoading == null)
                isShowLoading = !_this.state.isShowLoading;
            _this.setState({
                isShowLoading: isShowLoading
            });
        };
    };
    CheckOutLoading.prototype.render = function () {
        var isShowLoading = this.state.isShowLoading;
        return (React.createElement("div", { className: "cart-mask-bg cart-mask-bg-1", style: { zIndex: 1300, display: isShowLoading ? "block" : "none" } },
            React.createElement("div", { className: "cart-loading-img" })));
    };
    return CheckOutLoading;
}(React.Component));
exports.CheckOutLoading = CheckOutLoading;
var MaskLayer = /** @class */ (function (_super) {
    __extends(MaskLayer, _super);
    function MaskLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaskLayer.prototype.render = function () {
        return (React.createElement("div", { className: "mask_layer" },
            React.createElement("div", { className: "cart-loading-img" })));
    };
    return MaskLayer;
}(React.Component));
exports.MaskLayer = MaskLayer;
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHandleSignIn = function () {
            location.href = l.AccountAuthentication.getPassportLenovoUrl('NewLenovoLoginUrl');
        };
        _this.onHandleSignUp = function () {
            location.href = l.AccountAuthentication.getPassportLenovoUrl('NewLenovoSignupUrl');
        };
        return _this;
    }
    Login.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "cart-popup cart-popup3" },
            React.createElement("h4", null,
                React.createElement("span", null, l.Translator.translate("sign in title"))),
            React.createElement("div", { className: "dialog-text" },
                React.createElement("div", { className: "pro-detail pro-detail1 clearfix" },
                    React.createElement("div", { className: "table", dangerouslySetInnerHTML: { __html: window["LoginNote"] } }),
                    React.createElement("div", { className: "items-total" },
                        React.createElement("button", { onClick: function () { return _this.onHandleSignIn(); }, className: "btn btn-blue" }, l.Translator.translate("sign in button")),
                        React.createElement("button", { onClick: function () { return _this.onHandleSignUp(); }, className: "btn btn-default" }, l.Translator.translate("create lenovoid button")))))));
    };
    return Login;
}(React.Component));
exports.Login = Login;
var TopCartIcon = /** @class */ (function (_super) {
    __extends(TopCartIcon, _super);
    function TopCartIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.onHandleSetCount = function (count) {
            _this.setState({
                count: count
            });
        };
        _this.onHandleShowTopCart = function () {
            window["onHandleShowTopCart"]();
        };
        _this.state = {
            count: 0
        };
        return _this;
    }
    TopCartIcon.prototype.componentDidMount = function () {
        var _this = this;
        window["onHandleSetCount"] = function (count) { return _this.onHandleSetCount(count); };
    };
    TopCartIcon.prototype.render = function () {
        var _this = this;
        var count = this.state.count;
        return (React.createElement("a", { href: "javascript:void(0);", className: "wps-cart", onClick: function () { return _this.onHandleShowTopCart(); } },
            React.createElement("span", { className: "icon-cart" },
                React.createElement("i", { className: "icon_point", style: { display: count > 0 ? 'block' : 'none' } })),
            React.createElement("label", null, l.Translator.translate("cart")),
            React.createElement("span", { className: "lenovo-box-arrow-down" })));
    };
    return TopCartIcon;
}(React.Component));
var TopCart = /** @class */ (function (_super) {
    __extends(TopCart, _super);
    function TopCart(props) {
        var _this = _super.call(this, props) || this;
        _this.emptyCart = { Entries: [], TotalPrice: { FormattedValue: 0 }, TotalItems: 0, SerialNumber: "", MachineType: "" };
        _this.initSelectedTab = function () {
            if (utility_1.IsCanBuyParts())
                return utility_2.CartFlag.Parts;
            else if (utility_1.IsCanBuyAccessory())
                return utility_2.CartFlag.Accessories;
            else if (utility_1.IsCanBuyWarranty())
                return utility_2.CartFlag.Services;
        };
        _this.onHandleSetCount = function (count) {
            window["onHandleSetCount"](count);
        };
        _this.onHandleShowLoading = function (loadingType) {
            _this.setState({
                loadingType: loadingType
            });
        };
        _this.onHandleShowLogin = function (cartFlag) {
            if (cartFlag === void 0) { cartFlag = utility_2.CartFlag.Accessories; }
            _this.setState({
                isShowLogin: true,
                isShowContent: true,
                cartFlag: cartFlag
            });
        };
        _this.onHandleSwitch = function (cartFlag) {
            var loadingType = _this.state.loadingType;
            if (cartFlag != _this.state.cartFlag && (cartFlag != utility_2.CartFlag.Accessories || l.AccountAuthentication.isLogin()) && loadingType == null) {
                _this.onHandleLoadCartData(cartFlag);
                _this.setState({ data: _this.emptyCart });
            }
            _this.setState({
                cartFlag: cartFlag
            });
        };
        _this.onHandleShowError = function (errorCode, needCheckStock) {
            if (errorCode === void 0) { errorCode = "default"; }
            if (needCheckStock === void 0) { needCheckStock = false; }
            var eCommErrorCode = _this.state.eCommErrorCode;
            if (errorCode == "default")
                errorCode = eCommErrorCode;
            _this.setState({
                isShowContent: true,
                eCommErrorCode: errorCode,
                needCheckStock: needCheckStock
            });
        };
        _this.onHandleShowTopCart = function (isShowContent, cartFlag, isGetData) {
            if (isShowContent === void 0) { isShowContent = null; }
            if (cartFlag === void 0) { cartFlag = null; }
            if (isGetData === void 0) { isGetData = true; }
            var loadingType = _this.state.loadingType;
            if (cartFlag == null)
                cartFlag = _this.state.cartFlag;
            if (isShowContent == null)
                isShowContent = !_this.state.isShowContent;
            _this.setState({
                isShowContent: isShowContent,
                needCheckStock: false
            });
            if (isShowContent) {
                if ((cartFlag != utility_2.CartFlag.Accessories || l.AccountAuthentication.isLogin()) && loadingType == null && isGetData)
                    _this.onHandleLoadCartData(cartFlag, isShowContent);
            }
        };
        _this.state = {
            loadingType: null,
            isShowLogin: false,
            isShowContent: false,
            data: _this.emptyCart,
            cartFlag: _this.initSelectedTab(),
            isLoadingDataCompletion: false,
            eCommErrorCode: null,
            needCheckStock: false
        };
        return _this;
    }
    TopCart.prototype.componentDidMount = function () {
        var _this = this;
        var cartFlag = this.state.cartFlag;
        this.onHandleSetCount(0);
        this.onHandleLoadCartData(cartFlag);
        utility_2.onListenClickErea();
        window["onHandleShowLogin"] = function () { return _this.onHandleShowLogin(); };
        window["onHandleShowTopCart"] = function (isShowContent, cartFlag, isGetData) {
            if (isShowContent === void 0) { isShowContent = null; }
            if (cartFlag === void 0) { cartFlag = null; }
            if (isGetData === void 0) { isGetData = true; }
            return _this.onHandleShowTopCart(isShowContent, cartFlag, isGetData);
        };
        window["onHandleRefreshCartData"] = function (cartFlag, loadingType) {
            if (loadingType === void 0) { loadingType = utility_2.LoadingType.MiniLoading; }
            return _this.onHandleLoadCartData(cartFlag, null, false, loadingType);
        };
        //UPS-1340  Parameters for receiving eCom callbacks
        var errorCode = l.UrlUtility.getUrlParam("uscErrorCode", false);
        if (errorCode) {
            window.history.replaceState({}, '', "" + location.origin + location.pathname);
            //0000 is show cart
            if (errorCode == "0000")
                this.onHandleShowTopCart(true, null, true);
            else
                this.onHandleShowError(errorCode);
        }
    };
    TopCart.prototype.onHandleLoadCartData = function (cartFlag, isShowContent, getFromCache, loadingType) {
        if (cartFlag === void 0) { cartFlag = null; }
        if (isShowContent === void 0) { isShowContent = null; }
        if (getFromCache === void 0) { getFromCache = true; }
        if (loadingType === void 0) { loadingType = utility_2.LoadingType.MiniLoading; }
        if (cartFlag == null)
            cartFlag = this.state.cartFlag;
        if (isShowContent == null)
            isShowContent = this.state.isShowContent;
        //Fix bug UPS-470,two asynchronous requests are carried out at the same time, caching is disorderly.In the future it will be solved in other way
        if (localStorage.getItem("isCheckOut") != "True" && (isShowContent || common_1.WPSShop.IsHaveItemInCart(cartFlag))) {
            var _self = this;
            _self.setState({ loadingType: loadingType, isLoadingDataCompletion: false });
            utility_2.InterfaceUtility.getCartData({ getFromCache: getFromCache, cartFlag: cartFlag }, function (rs) {
                if (rs.code === 200) {
                    //Record the status of the shopping cart. If there is one or more Part in the cart, record the global variable as True, otherwise False
                    if (utility_1.IsUsingUnifiedCart()) {
                        var isHavaPartInCart = rs.data.Entries.filter(function (item) { return item.Product.Type == "Part"; }).length > 0;
                        cartFlag = isHavaPartInCart ? utility_2.CartFlag.Parts : utility_2.CartFlag.Accessories;
                    }
                    //https://jira.xpaas.lenovo.com/browse/UPS-1407
                    var warrantyEntries = rs.data.Entries.filter(function (item) { return item.Product.Type == "Warranty"; });
                    if (warrantyEntries.length > 0) {
                        var warrantyNumbers = warrantyEntries.map(function (m) { return m.Product.Code; });
                        var sn = warrantyEntries[0].SerialNumber;
                        var mt = warrantyEntries[0].MachineType;
                        localStorage.setItem("UpgradeWarrantyCart", JSON.stringify({ SN: sn, MT: mt, IDs: warrantyNumbers }));
                    }
                    else
                        localStorage.removeItem("UpgradeWarrantyCart");
                    common_1.WPSShop.SetCookiesForCart(cartFlag, rs.data.Entries.length > 0 ? true : false);
                    _self.setState({ data: rs.data, loadingType: null, cartFlag: cartFlag, isLoadingDataCompletion: true });
                    _self.onHandleSetCount(rs.data.TotalItems);
                }
                else
                    _self.setState({ data: _self.emptyCart, loadingType: null, cartFlag: cartFlag, isLoadingDataCompletion: true });
            }, function (error) {
                console.log(JSON.stringify(error));
                _self.setState({ data: _self.emptyCart, loadingType: null, cartFlag: cartFlag, isLoadingDataCompletion: true });
            });
        }
        else {
            this.setState({ isLoadingDataCompletion: true });
        }
    };
    TopCart.prototype.render = function () {
        var _this = this;
        var _a = this.state, cartFlag = _a.cartFlag, data = _a.data, isShowContent = _a.isShowContent, loadingType = _a.loadingType, isShowLogin = _a.isShowLogin, isLoadingDataCompletion = _a.isLoadingDataCompletion, eCommErrorCode = _a.eCommErrorCode, needCheckStock = _a.needCheckStock;
        return (React.createElement("section", null,
            React.createElement("div", { className: "shoppingcart_wrapper", style: { display: isShowContent ? "block" : "none" } },
                React.createElement("h1", null, l.Translator.translate("summary view")),
                React.createElement("span", { className: "closebtn icon-l-close", onClick: function () { return _this.onHandleShowTopCart(false); } }),
                eCommErrorCode ?
                    React.createElement("div", { className: "cart_tab" },
                        React.createElement("div", { className: "tab_content" },
                            React.createElement("div", { className: "content_details" },
                                (function () {
                                    switch (eCommErrorCode) {
                                        case "0001":
                                            return React.createElement("div", null, l.Translator.translate("unavailable cart message"));
                                        case "0002":
                                            return React.createElement("div", null, l.Translator.translate("insufficient stock message"));
                                        case "0003":
                                            return React.createElement("div", null, l.Translator.translate("price changed message"));
                                        case "0004":
                                            return React.createElement("div", null, l.Translator.translate("server error message"));
                                        default:
                                            return React.createElement("div", null, l.Translator.translate("server error message"));
                                    }
                                })(),
                                React.createElement("div", { className: "cart_btn" },
                                    React.createElement("button", { onClick: function () { return _this.onHandleShowError(null, eCommErrorCode == "0002" ? true : false); }, style: { backgroundColor: "rgb(0, 157, 217)" } }, l.Translator.translate("view my cart")))))) :
                    React.createElement("div", { className: "cart_tab" },
                        (function () {
                            if (!utility_1.IsUsingUnifiedCart()) {
                                return (React.createElement("ul", { className: "tab_title clearfix" },
                                    utility_1.IsCanBuyParts() ? React.createElement("li", { className: cartFlag === utility_2.CartFlag.Parts ? 'active' : '', onClick: function () { return _this.onHandleSwitch(utility_2.CartFlag.Parts); } }, l.Translator.translate("parts")) : "",
                                    utility_1.IsCanBuyAccessory() ? React.createElement("li", { className: cartFlag === utility_2.CartFlag.Accessories ? 'active' : '', onClick: function () { return _this.onHandleSwitch(utility_2.CartFlag.Accessories); } }, l.Translator.translate("accessories")) : "",
                                    utility_1.IsCanBuyWarranty() ? React.createElement("li", { className: cartFlag === utility_2.CartFlag.Services ? 'active' : '', onClick: function () { return _this.onHandleSwitch(utility_2.CartFlag.Services); } }, l.Translator.translate("services")) : ""));
                            }
                        })(),
                        React.createElement("div", { style: { display: loadingType == utility_2.LoadingType.MiniLoading ? "block" : "none", textAlign: "center", marginTop: "20px", marginBottom: "20px" } },
                            React.createElement("img", { src: "/msa/parts/images/loading.gif" })),
                        React.createElement("div", { className: "tab_content", style: { display: loadingType != utility_2.LoadingType.MiniLoading ? "block" : "none" } }, !utility_1.IsUsingUnifiedCart() && cartFlag == utility_2.CartFlag.Accessories && (isShowLogin || !l.AccountAuthentication.isLogin()) ?
                            React.createElement(Login, null) :
                            React.createElement(DataList, { key: cartFlag, data: data, cartFlag: cartFlag, isShowContent: isShowContent, onHandleShowLoading: this.onHandleShowLoading, onHandleShowTopCart: this.onHandleShowTopCart, isLoadingDataCompletion: isLoadingDataCompletion, needCheckStock: needCheckStock }))),
                loadingType == utility_2.LoadingType.MaskLayer ? React.createElement(MaskLayer, null) : ""),
            React.createElement("form", { method: "POST", id: "checkoutForm" },
                React.createElement("input", { type: 'hidden', name: 'anonymous', id: "anonymous" }),
                React.createElement("input", { type: 'hidden', name: 'userid', id: "userid" }),
                React.createElement("input", { type: 'hidden', name: 'userId', id: "userId" }),
                React.createElement("input", { type: 'hidden', name: 'guid', id: "guid" }),
                React.createElement("input", { type: 'hidden', name: 'token', id: "token" }),
                React.createElement("input", { type: "hidden", name: "partsalesTargetUrl", id: "partsalesTargetUrl" }),
                React.createElement("input", { type: 'hidden', name: 'errorUrl', id: "errorUrl" })),
            React.createElement(CheckOutLoading, null)));
    };
    return TopCart;
}(React.Component));
var DataList = /** @class */ (function (_super) {
    __extends(DataList, _super);
    function DataList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.children = [];
        //Register child methods in parent components
        _this.onHandleRef = function (ref) {
            if (!_this.children) {
                _this.children = [];
            }
            //ID of current data
            //Method of checking quantity
            _this.children.push({
                ID: ref.props.item.Product.Code,
                CheckStock: ref.onHandleCheckStock
            });
        };
        _this.onHandleCheckStock = function () {
            _this.children.forEach(function (item) { item.CheckStock(); });
        };
        _this.onHandleCheckOut = function (isGuestCheckOut) {
            if (isGuestCheckOut === void 0) { isGuestCheckOut = false; }
            var _a = _this.props, cartFlag = _a.cartFlag, data = _a.data, isLoadingDataCompletion = _a.isLoadingDataCompletion;
            //https://jira.xpaas.lenovo.com/browse/COMM-2850
            //isLoadingDataCompletion:  shopping cart has been requested to complete?
            //isGuestCheckOut: Is it submitted anonymously?
            //this.children.length <= 0: Each line is loaded.
            if (!isLoadingDataCompletion && isGuestCheckOut && _this.children.length <= 0) {
                var thisorg = _this;
                window["onHandleShowCheckOutLoading"](true);
                setTimeout(function () {
                    thisorg.onHandleCheckOut(true);
                }, 500);
            }
            else {
                //Check the results of each data
                var checkResultArr = [];
                _this.children.map(function (item) {
                    checkResultArr.push(item.CheckStock());
                });
                window["onHandleShowCheckOutLoading"](false);
                if (checkResultArr.filter(function (item) { return !item; }).length == 0 && data.TotalItems > 0)
                    common_1.WPSShop.GoToCheckOut(cartFlag, isGuestCheckOut);
                else
                    window["onHandleShowTopCart"](true, null, false);
            }
        };
        _this.onHandleContinueShopping = function () {
            var _a = _this.props, onHandleShowTopCart = _a.onHandleShowTopCart, cartFlag = _a.cartFlag;
            onHandleShowTopCart(false);
            common_1.WPSShop.GoShopping(cartFlag);
        };
        return _this;
    }
    DataList.prototype.componentDidMount = function () {
        var _this = this;
        window["onHandleCheckOut"] = function (isGuestCheckOut) {
            if (isGuestCheckOut === void 0) { isGuestCheckOut = false; }
            return _this.onHandleCheckOut(isGuestCheckOut);
        };
        var needCheckStock = this.props.needCheckStock;
        if (needCheckStock) {
            this.onHandleCheckStock();
        }
    };
    DataList.prototype.componentWillUpdate = function (nextProps, nextState) {
        var data = nextProps.data;
        var newChildren = [];
        var ids = data.Entries.map(function (item) { return item.Product.Code; });
        this.children.map(function (children) {
            //Filtration weight removal
            if (ids.indexOf(children.ID) > -1 && newChildren.filter(function (newChildren) { return newChildren.ID == children.ID; }).length == 0)
                newChildren.push(children);
        });
        this.children = newChildren;
    };
    DataList.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, cartFlag = _a.cartFlag, onHandleShowLoading = _a.onHandleShowLoading, isShowContent = _a.isShowContent;
        var hasData = data.Entries && data.Entries.length > 0;
        var notSaleable = false;
        data.Entries.map(function (item, index) {
            if (item.NotSaleable == true)
                notSaleable = true;
        });
        return (React.createElement("div", { className: "content_details" },
            hasData ?
                React.createElement("div", { className: "list_title clearfix" },
                    React.createElement("div", null, l.Translator.translate("title")),
                    React.createElement("div", null, l.Translator.translate("part")),
                    React.createElement("div", null, l.Translator.translate("qty")),
                    React.createElement("div", null, l.Translator.translate("price")),
                    React.createElement("div", null, l.Translator.translate("total")))
                : React.createElement("div", null,
                    l.Translator.translate("empty cart message"),
                    "!"),
            React.createElement("div", { className: "lists_box" }, hasData ? data.Entries.map(function (item, index) {
                return (React.createElement(ListRow, { item: item, key: item.Product.Code + index, cartFlag: cartFlag, cartID: data.Guid, onRef: _this.onHandleRef, isShowContent: isShowContent, onHandleShowLoading: onHandleShowLoading }));
            }) : ""),
            (function () {
                //Checkout buttons are not displayed on the ShopLogin page
                if (location.href.indexOf('shoplogin') < 0) {
                    return (React.createElement("div", { className: "cart_btn" }, hasData ?
                        React.createElement("button", { onClick: function () { return _this.onHandleCheckOut(); }, disabled: notSaleable, style: notSaleable ? { backgroundColor: '#ccc', border: 0, cursor: 'no-drop' } : { backgroundColor: '#009DD9' } }, l.Translator.translate("checkout"))
                        : utility_1.IsUsingUnifiedCart() ? "" : React.createElement("button", { onClick: function () { return _this.onHandleContinueShopping(); } }, l.Translator.translate("go shopping"))));
                }
            })()));
    };
    return DataList;
}(React.Component));
var ListRow = /** @class */ (function (_super) {
    __extends(ListRow, _super);
    function ListRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onHandleCheckStock = function () {
            var item = _this.props.item;
            //UPS-749
            //If the current number of shopping carts is larger than the inventory, and the inventory is greater than 0
            if (item.Quantity > item.Stock && item.Stock > 0) {
                item.Quantity = item.Stock;
                _this.setState({
                    isShowUpdate: false,
                    numberVal: item.Stock,
                    isShowOutOfStock: true
                });
                //Trigger the API to update the number
                _this.onHandleUpdateQuantity(false, item.Stock);
                //Display prompts with timers
                _this.onHandleTimer();
                return false;
            }
            return true;
        };
        _this.onHandleTimer = function () {
            //At the same time, there can only be one timer
            clearInterval(_this.state.timer);
            _this.setState({
                timerNumber: 5,
                timer: setInterval(function () {
                    _this.setState(function (preState) { return ({
                        timerNumber: preState.timerNumber - 1,
                    }); }, function () {
                        if (_this.state.timerNumber == 0) {
                            clearInterval(_this.state.timer);
                            _this.onHandleHideOutOfStock();
                        }
                    });
                }, 1000)
            });
        };
        _this.onHandleChange = function (event) {
            var item = _this.props.item;
            var isShowUpdate = false;
            var isShowOutOfStock = false;
            var val = event.target.value.length <= 0 ? 0 : parseInt(event.target.value);
            //If the number of changes is greater than inventory
            if (val > item.Stock) {
                if (item.Stock > 0) {
                    //Set the current quantity to the maximum inventory
                    val = item.Stock;
                    //Display prompt information
                    isShowOutOfStock = true;
                    //Display prompts with timers
                    _this.onHandleTimer();
                }
                else
                    val = item.Quantity;
            }
            if (val > 0 && val != item.Quantity)
                isShowUpdate = true;
            _this.setState({
                isShowUpdate: isShowUpdate,
                numberVal: val <= 0 ? "" : val.toString(),
                isShowOutOfStock: isShowOutOfStock
            });
        };
        _this.onHandleHideOutOfStock = function () {
            clearInterval(_this.state.timer);
            _this.setState({
                timer: null,
                timerNumber: null,
                isShowOutOfStock: false,
            });
        };
        _this.onHandleUpdateQuantity = function (refreshCartData, numberVal, isShowOutOfStock) {
            if (refreshCartData === void 0) { refreshCartData = true; }
            if (numberVal === void 0) { numberVal = 0; }
            if (isShowOutOfStock === void 0) { isShowOutOfStock = false; }
            numberVal = numberVal || _this.state.numberVal;
            var _a = _this.props, item = _a.item, cartFlag = _a.cartFlag, cartID = _a.cartID, onHandleShowLoading = _a.onHandleShowLoading;
            var postData = { cartFlag: cartFlag, entryGuid: item.Guid, type: item.Product.Type, entryNumber: item.EntryNumber, code: item.Product.Code, quantity: numberVal, cartID: cartID };
            if (refreshCartData) {
                onHandleShowLoading(utility_2.LoadingType.MaskLayer);
                utility_2.InterfaceUtility.updateQuantity(postData, function (rs) {
                    if (rs.code == 604)
                        _this.onHandleUpdateQuantity(true, rs.msg, true);
                    else {
                        _this.setState({ isShowUpdate: false, numberVal: rs.code == 200 ? numberVal : item.Quantity, isShowOutOfStock: rs.code == 603 || isShowOutOfStock });
                        window["onHandleRefreshCartData"](cartFlag, utility_2.LoadingType.MaskLayer);
                    }
                }, function (error) {
                    console.log(JSON.stringify(error));
                    _this.setState({ isShowUpdate: false });
                    window["onHandleRefreshCartData"](cartFlag, utility_2.LoadingType.MaskLayer);
                });
            }
            else
                utility_2.InterfaceUtility.updateQuantity(postData, function (rs) { console.log("Update successful"); }, function (error) { console.log("Update fail" + JSON.stringify(error)); });
        };
        _this.onHandleRemove = function () {
            var _a = _this.props, item = _a.item, cartFlag = _a.cartFlag, cartID = _a.cartID, onHandleShowLoading = _a.onHandleShowLoading;
            onHandleShowLoading(utility_2.LoadingType.MaskLayer);
            var postData = { cartFlag: cartFlag, entryGuid: item.Guid, type: item.Product.Type, entryNumber: item.EntryNumber, code: item.Product.Code, cartID: cartID };
            utility_2.InterfaceUtility.removeEntry(postData, function (rs) {
                window["onHandleRefreshCartData"](cartFlag, utility_2.LoadingType.MaskLayer);
            }, function (error) {
                console.log(JSON.stringify(error));
                window["onHandleRefreshCartData"](cartFlag, utility_2.LoadingType.MaskLayer);
            });
        };
        _this.state = {
            isShowUpdate: false,
            isShowOutOfStock: false,
            numberVal: _this.props.item.Quantity || 1
        };
        return _this;
    }
    ListRow.prototype.componentWillReceiveProps = function (nextProps, nextState) {
        if (!nextProps.item || this.props.item === nextProps.item) {
            return;
        }
        this.setState({
            numberVal: nextProps.item.Quantity || 1
        });
    };
    ListRow.prototype.componentDidMount = function () {
        this.props.onRef(this);
    };
    ListRow.prototype.componentWillUpdate = function (nextProps, nextState) {
        var item = nextProps.item;
        if (nextProps.item.Quantity != this.props.item.Quantity) {
            nextState.isShowUpdate = false;
            nextState.numberVal = item.Quantity && item.Quantity > 0 ? item.Quantity : 1;
        }
    };
    ListRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, cartFlag = _a.cartFlag;
        var _b = this.state, numberVal = _b.numberVal, isShowUpdate = _b.isShowUpdate, isShowOutOfStock = _b.isShowOutOfStock, timerNumber = _b.timerNumber;
        var isParts = item.Product.Type == "Part";
        var isAccessory = item.Product.Type == "Accessory";
        var isWarranty = item.Product.Type == "Warranty";
        return (React.createElement("div", null,
            React.createElement("div", { className: "list_row clearfix" },
                React.createElement("div", { className: "left_column" }, (function () {
                    if (item.Product.Image && item.Product.Image.length > 0) {
                        return (React.createElement(ImageItem_1.ImageItem, { image: item.Product.Image[0], isAccessory: isAccessory, isParts: isParts }));
                    }
                    else {
                        if (isWarranty)
                            return React.createElement("img", { className: "warranty_img", src: "/msa/parts/images/pcg/icon-house.png" });
                        else
                            return React.createElement("span", { className: "noimg_icon" },
                                React.createElement("span", { className: "partsaccessories-parts-cart" }));
                    }
                })()),
                React.createElement("div", { className: "right_column" },
                    React.createElement("div", { className: "first_line" },
                        React.createElement("div", null,
                            React.createElement("span", { className: "text", title: item.Product.Name }, item.Product.Name)),
                        React.createElement("div", null, (function () {
                            if (isWarranty)
                                return React.createElement("span", null, item.Product.Code);
                            else if (isParts)
                                return React.createElement("a", { onClick: function () { return common_1.WPSShop.ShowPart(item.Product.Code, utility_2.CartFlag.Parts); } }, item.Product.Code);
                            else if (isAccessory)
                                return React.createElement("a", { onClick: function () { return common_1.WPSShop.ShowPart(item.Product.Code, utility_2.CartFlag.Accessories); } }, item.Product.Code);
                        })()),
                        React.createElement("div", null,
                            React.createElement("input", { min: 1, type: "number", value: numberVal, "data-stock": item.Stock, style: { textAlign: "center" }, onChange: function (e) { _this.onHandleChange(e); }, onKeyPress: function (e) { !/^[0-9]*$/.test(e.key) ? e.preventDefault() : ""; }, onBlur: function () { numberVal == "" ? _this.setState({ numberVal: item.Quantity }) : ""; }, disabled: (item.NotSaleable || isWarranty) ? true : false }),
                            isShowUpdate ? React.createElement("a", { style: { marginTop: "5px", display: "block" }, href: "javascript:void(0)", onClick: function () { return _this.onHandleUpdateQuantity(); } }, l.Translator.translate("update")) : ""),
                        React.createElement("div", null, item.BasePrice.FormattedValue),
                        React.createElement("div", null,
                            React.createElement("span", null, item.TotalPrice.FormattedValue),
                            React.createElement("span", { className: "icon icon-remove", onClick: function () { return _this.onHandleRemove(); } }))),
                    item.NotSaleable ?
                        React.createElement("div", { className: "second_line" },
                            React.createElement("span", null, l.Translator.translate("not saleable part message"))) : "")),
            isShowOutOfStock ?
                React.createElement("div", { className: "oos_tips clearfix" },
                    React.createElement("div", null, l.Translator.translate("quantity changed message")),
                    React.createElement("div", null,
                        React.createElement("span", { onClick: function () { return _this.onHandleHideOutOfStock(); } },
                            l.Translator.translate("ok"),
                            timerNumber ? "(" + timerNumber + ")" : ""))) : ""));
    };
    return ListRow;
}(React.Component));
exports.render = function () {
    utility_2.operationDocument();
    ReactDOM.render(React.createElement(TopCartIcon, null), $(".desktop-header .wps-cart-box")[0]);
    ReactDOM.render(React.createElement(TopCart, null), $("#" + utility_2.topCartId)[0]);
};
